import { MutationTree } from 'vuex'
import * as types from './mutation-types'
import CartState from '../types/CartState'

const mutations: MutationTree<CartState> = {
  [types.CART_PROCESSING] (state, value) {
    state.processing = value
  },
  [types.CART_SOURCE] (state, value) {
    state.source = value
  }
}

export default mutations
